import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';
import { theme } from '@sg/garnish';

export const UpsellContainer = ({ children, style }: UpsellContainerProps) => {
  return <View style={[styles.container, style]}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: theme.colors.WHITE,
    marginHorizontal: theme.spacing['10'],
    marginBottom: theme.spacing['10'],
    borderRadius: theme.radius.xxlarge,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type UpsellContainerProps = PropsWithChildren<{
  style?: ViewStyle;
}>;
